import AppTradeFairGlobal from '@/pages/AppTradeFairGlobal/Template'
import Points from '@/pages/AppTradeFairGlobal/Points'
import Order from '@/pages/AppTradeFairGlobal/Order'
import Account from '@/pages/AppTradeFairGlobal/Account'
export default {
    path: '/AppTradeFairGlobal',
    component: AppTradeFairGlobal,
    children: [
        {
            path: '',
            name: 'AppTradeFairGlobalPoints',
            component: Points,
        },
        {
            path: ':id/:id1',
            name: 'AppTradeFairGlobalOrder',
            component: Order,
        },
        {
            path: 'account',
            name: 'AppTradeFairGlobalAccount',
            component: Account,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/apptradefairglobal.js